<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="isler_detay">



            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between g-3">
                                    <div class="nk-block-head-content">


                                        <h3 class="nk-block-title page-title">Tfon Machine Fair Interview Form / Tfon Makine Fuar Görüşme Formu </h3>
                                  

                                    </div>
                                    <div class="nk-block-head-content">
                                        <router-link to="/gorusmebilgiler"
                                            class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                                class="icon ni ni-arrow-left"></em><span>Archive / Tüm Görüşmeler</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <form @submit.prevent="gonder">

                            <div class="row">
                            <div class="col-sm-8">
                              

                               
                                
                         


                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">COMPANY INFORMATION / FİRMA BİLGİLERİ</span>
                                        <div class="row gy-4">

                  
                                        <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.etkinlik }">
                                                    <label class="form-label" for="default-textarea">Fair / Fuar</label>
                                                    <div class="form-control-wrap">
                                                        <v-select
                                                        v-model="localFormData.etkinlik"
                                                        :options="etkinlikler"
                                                        label="ad"
                                                        :reduce="etkinlik => etkinlik.id"
                                                        placeholder="Etkinlik Seçin"
                                                        />
                                                    </div>
                                                    <span v-if="formHatalar.etkinlik" class="error">{{ formHatalar.etkinlik }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firma }">
                                                    <label class="form-label" for="default-textarea">Registered Company / Kayıtlı Firma</label>
                                                    <div class="form-control-wrap">
                                                          <v-select
                                                                v-model="localFormData.firma"
                                                                :options="firmalar"
                                                                label="unvan"
                                                                :reduce="firma => firma.id"
                                                                placeholder="Firma Seçin" />
                                                    </div>
                                                    <span v-if="formHatalar.musteri" class="error">{{ formHatalar.firma }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.kisi }">
                                                    <label class="form-label" for="default-textarea">
                                                        Registered Company Official / Kayıtlı Firma Yetkilisi</label>
                                                    <div class="form-control-wrap">
                                                          <v-select
                                                                v-model="localFormData.kisi"
                                                                :options="kisiler"
                                                                label="adsoyad"
                                                                :reduce="kisi => kisi.id"
                                                                placeholder="Kişi Seçin" />
                                                    </div>
                                                    <span v-if="formHatalar.kisi" class="error">{{ formHatalar.kisi }}</span>
                                                </div>
                                            </div>

                                            



                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmaad }">
                                                    <label class="form-label" for="default-01">Company Name / Firma Adı</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmaad" v-model="localFormData.firmaad">
                                                    </div>
                                                    <span v-if="formHatalar.firmaad" class="error">{{ formHatalar.firmaad }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmaulke }">
                                                    <label class="form-label" for="default-01">Country / Ülke</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmaulke" v-model="localFormData.firmaulke">
                                                    </div>
                                                    <span v-if="formHatalar.firmaulke" class="error">{{ formHatalar.firmaulke }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-6">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmaemail }">
                                                    <label class="form-label" for="default-01">Company Email / Firma Email</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmaemail" v-model="localFormData.firmaemail">
                                                    </div>
                                                    <span v-if="formHatalar.firmaemail" class="error">{{ formHatalar.firmaemail }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmatelefon }">
                                                    <label class="form-label" for="default-01">Company Phone / Firma Telefon</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmatelefon" v-model="localFormData.firmatelefon">
                                                    </div>
                                                    <span v-if="formHatalar.firmatelefon" class="error">{{ formHatalar.firmatelefon }}</span>
                                                </div>
                                            </div>

       
                                            <div class="col-sm-6">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmakisiadsoyad }">
                                                    <label class="form-label" for="default-01">Name Surname / Ad Soyad</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmakisiadsoyad" v-model="localFormData.firmakisiadsoyad">
                                                    </div>
                                                    <span v-if="formHatalar.firmakisiadsoyad" class="error">{{ formHatalar.firmakisiadsoyad }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-6">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmakisiunvan }">
                                                    <label class="form-label" for="default-01">Title / Ünvan</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmakisiunvan" v-model="localFormData.firmakisiunvan">
                                                    </div>
                                                    <span v-if="formHatalar.firmakisiunvan" class="error">{{ formHatalar.firmakisiunvan }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-6">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmakisiemail }">
                                                    <label class="form-label" for="default-01">Email / Firma Temsilci Email</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmakisiemail" v-model="localFormData.firmakisiemail">
                                                    </div>
                                                    <span v-if="formHatalar.firmakisiemail" class="error">{{ formHatalar.firmakisiemail }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.firmakisitelefon }">
                                                    <label class="form-label" for="default-01">Phone / Firma Temsilci Telefon</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="text"  id="firmakisitelefon" v-model="localFormData.firmakisitelefon">
                                                    </div>
                                                    <span v-if="formHatalar.firmakisitelefon" class="error">{{ formHatalar.firmakisitelefon }}</span>
                                                </div>
                                            </div>
                                         

                                            
                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.tarih }">
                                                    <label class="form-label" for="tarih">Date / Görüşme Tarihi</label>
                                                    <div class="form-control-wrap">
                                                         <VueCtkDateTimePicker 
                                                         itemid="tarih"
                                                        color="#364a63"
                                                        button-color="#5A770E" v-model="localFormData.tarih"
                                                        format="YYYY-MM-DD HH:mm:ss" label="Görüşme Tarihi Seçiniz"
                                                        button-now-translation="Bugün" />
                                                    </div>
                                                    <span v-if="formHatalar.tarih" class="error">{{ formHatalar.tarih }}</span>
                                                </div>
                                            </div>

                                     
                                    

                                         

                                        
                                        </div>
                                 
                                 
                                    </div>
                                </div>
                            </div>

                          

                          

                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">Metarial Dimensions / Malzeme Alt Yapısı</span>
                                        <div class="row gy-4">
                                            
                                            <div class="col-sm-2">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.lazer }">
                                                    <input type="checkbox" class="custom-control-input" id="lazer"  v-model="localFormData.lazer">
                                                    <label class="custom-control-label" for="lazer">Laser / Lazer</label>
                                                    <span v-if="formHatalar.lazer" class="error">{{ formHatalar.lazer
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.plazma }">
                                                    <input type="checkbox" class="custom-control-input" id="plazma"  v-model="localFormData.plazma">
                                                    <label class="custom-control-label" for="plazma">Plasma / Plazma</label>
                                                    <span v-if="formHatalar.plazma" class="error">{{ formHatalar.plazma
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.oksijen }">
                                                    <input type="checkbox" class="custom-control-input" id="oksijen"  v-model="localFormData.oksijen">
                                                    <label class="custom-control-label" for="oksijen">Oxygen / Oksijen</label>
                                                    <span v-if="formHatalar.oksijen" class="error">{{ formHatalar.oksijen
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.punch }">
                                                    <input type="checkbox" class="custom-control-input" id="punch"  v-model="localFormData.punch">
                                                    <label class="custom-control-label" for="punch">Punch / Punch</label>
                                                    <span v-if="formHatalar.punch" class="error">{{ formHatalar.punch
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.diger }">
                                                    <input type="checkbox" class="custom-control-input" id="diger"  v-model="localFormData.diger">
                                                    <label class="custom-control-label" for="diger">Other / Diğer</label>
                                                    <span v-if="formHatalar.diger" class="error">{{ formHatalar.diger
                                                    }}</span>
                                                </div>
                                            </div>
                                           
                                          
                                    
                                    
                                        
                                        </div>

                                    
   
                                 
                                 
                                    </div>
                                </div>
                            </div>


                     


                        

                        <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title"> DEBURRING AND EDGE ROUNDING MACHINE / ÇAPAK ALMA VE KENAR YUVARLAMA</span>
                                        <div class="row gy-4">
                                          

                                     


                                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.taslamapersonelsayi }">
                                                    <label class="form-label" for="default-01">Number of Grinding Personnel /Taşlama Personel Sayısı</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="number"  id="taslamapersonelsayi" v-model="localFormData.taslamapersonelsayi">
                                                    </div>
                                                    <span v-if="formHatalar.taslamapersonelsayi" class="error">{{ formHatalar.taslamapersonelsayi }}</span>
                                                </div>
                                            </div>

                                      

                               
                                      

                                            <div class="col-sm-3 d-flex gap-2">
                                                <label  >Material Thickness Range / Malzeme Kalınlığı Aralığı</label>  

                                            </div>

                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemekalinligiaraligi }">
                                                    <input type="radio" class="custom-control-input" id="malzemekalinligiaraligi1" value="0-120" v-model="localFormData.malzemekalinligiaraligi" >
                                                    <label class="custom-control-label" for="malzemekalinligiaraligi1">0-120</label>
                                                    <span v-if="formHatalar.malzemekalinligiaraligi" class="error">{{ formHatalar.malzemekalinligiaraligi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemekalinligiaraligi }">
                                                    <input type="radio" class="custom-control-input" id="malzemekalinligiaraligi2" value="120uzeri" v-model="localFormData.malzemekalinligiaraligi" >
                                                    <label class="custom-control-label" for="malzemekalinligiaraligi2">Above 120/ 120 Üzeri</label>
                                                    <span v-if="formHatalar.malzemekalinligiaraligi" class="error">{{ formHatalar.malzemekalinligiaraligi
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 d-flex gap-2">
                                                <label>Material Width Range / Malzeme Genişlik Aralığı</label>  

                                            </div>

                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemegenislikaraligi }">
                                                    <input type="radio" class="custom-control-input" id="malzemegenislikaraligi1" value="650" v-model="localFormData.malzemegenislikaraligi" >
                                                    <label class="custom-control-label" for="malzemegenislikaraligi1">0-650</label>
                                                    <span v-if="formHatalar.malzemegenislikaraligi" class="error">{{ formHatalar.malzemegenislikaraligi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemegenislikaraligi }">
                                                    <input type="radio" class="custom-control-input" id="malzemegenislikaraligi2" value="1000" v-model="localFormData.malzemegenislikaraligi" >
                                                    <label class="custom-control-label" for="malzemegenislikaraligi2">0-1000</label>
                                                    <span v-if="formHatalar.malzemegenislikaraligi" class="error">{{ formHatalar.malzemegenislikaraligi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemegenislikaraligi }">
                                                    <input type="radio" class="custom-control-input" id="malzemegenislikaraligi3" value="1300" v-model="localFormData.malzemegenislikaraligi" >
                                                    <label class="custom-control-label" for="malzemegenislikaraligi3">0-1300</label>
                                                    <span v-if="formHatalar.malzemegenislikaraligi" class="error">{{ formHatalar.malzemegenislikaraligi
                                                    }}</span>
                                                </div>
                                            </div>
                                        
                                            <div class="col-sm-3 d-flex gap-2">
                                                <label>Material Quality / Malzeme Kalitesi</label>  

                                            </div>

                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemekalitesi }">
                                                    <input type="radio" class="custom-control-input" id="malzemekalitesi1" value="celik" v-model="localFormData.malzemekalitesi" >
                                                    <label class="custom-control-label" for="malzemekalitesi1">Steel / Çelik</label>
                                                    <span v-if="formHatalar.malzemekalitesi" class="error">{{ formHatalar.malzemekalitesi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemekalitesi }">
                                                    <input type="radio" class="custom-control-input" id="malzemekalitesi2" value="aliminyum" v-model="localFormData.malzemekalitesi" >
                                                    <label class="custom-control-label" for="malzemekalitesi2">Aluminum / Alüminyum</label>
                                                    <span v-if="formHatalar.malzemekalitesi" class="error">{{ formHatalar.malzemekalitesi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemekalitesi }">
                                                    <input type="radio" class="custom-control-input" id="malzemekalitesi3" value="paslanmaz" v-model="localFormData.malzemekalitesi" >
                                                    <label class="custom-control-label" for="malzemekalitesi3">Stainless/ Paslanmaz</label>
                                                    <span v-if="formHatalar.malzemekalitesi" class="error">{{ formHatalar.malzemekalitesi
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 d-flex gap-2">
                                                    <label>Material Shape / Malzeme Şekli</label>  

                                                </div>

                                                <div class="col-sm-3">
                                                    <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemesekli }">
                                                        <input type="radio" class="custom-control-input" id="malzemesekli1" value="levha" v-model="localFormData.malzemesekli" >
                                                        <label class="custom-control-label" for="malzemesekli1">Plate / Levha</label>
                                                        <span v-if="formHatalar.malzemesekli" class="error">{{ formHatalar.malzemesekli
                                                        }}</span>
                                                    </div>
                                                    
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemesekli }">
                                                        <input type="radio" class="custom-control-input" id="malzemesekli2" value="profil" v-model="localFormData.malzemesekli" >
                                                        <label class="custom-control-label" for="malzemesekli2">Profile / Profil</label>
                                                        <span v-if="formHatalar.malzemesekli" class="error">{{ formHatalar.malzemesekli
                                                        }}</span>
                                                    </div>
                                                </div>
                                                <div class="col-sm-3">
                                                    <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemesekli }">
                                                        <input type="radio" class="custom-control-input" id="malzemesekli3" value="diger" v-model="localFormData.malzemesekli" >
                                                        <label class="custom-control-label" for="malzemesekli3">Other / Diğer</label>
                                                        <span v-if="formHatalar.malzemesekli" class="error">{{ formHatalar.malzemesekli
                                                        }}</span>
                                                    </div>
                                                </div>


                                                                                
                                   

                                     <div class="col-sm-3 d-flex gap-2 mb-2">
                                            <label>Holder System / Tutucu Sistem</label>  

                                        </div>

                                        <div class="col-sm-3">
                                            <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.tutucusistem }">
                                                <input type="radio" class="custom-control-input" id="tutucusistem" value="manyetik" v-model="localFormData.tutucusistem" >
                                                <label class="custom-control-label" for="tutucusistem">Magnetic / Manyetik</label>
                                                <span v-if="formHatalar.tutucusistem" class="error">{{ formHatalar.tutucusistem
                                                }}</span>
                                            </div>
                                            
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.tutucusistem }">
                                                <input type="radio" class="custom-control-input" id="tutucusistem2" value="vakumlu" v-model="localFormData.tutucusistem" >
                                                <label class="custom-control-label" for="tutucusistem2">Vacuum / Vakumlu</label>
                                                <span v-if="formHatalar.tutucusistem" class="error">{{ formHatalar.tutucusistem
                                                }}</span>
                                            </div>
                                        </div>
                                    
   

                                     
                                    

                                         

                                        
                                        </div>
                                 
                                 
                                    </div>
                                </div>
                            </div>

                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">MACHINE STATIONS / MAKİNE İSTASYONLARI</span>
                                        <div class="row gy-4">
                                            
                                            <div class="col-sm-4">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.agircapakalma }">
                                                    <input type="checkbox" class="custom-control-input" id="agircapakalma"  v-model="localFormData.agircapakalma">
                                                    <label class="custom-control-label" for="agircapakalma">Heavy Deburring / Ağır Çapak Alma </label>
                                                    <span v-if="formHatalar.agircapakalma" class="error">{{ formHatalar.agircapakalma
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.yuzeycapakalma }">
                                                    <input type="checkbox" class="custom-control-input" id="yuzeycapakalma"  v-model="localFormData.yuzeycapakalma">
                                                    <label class="custom-control-label" for="yuzeycapakalma">Surface Deburring / Yüzey Çapak Alma</label>
                                                    <span v-if="formHatalar.yuzeycapakalma" class="error">{{ formHatalar.yuzeycapakalma
                                                    }}</span>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.kenaryuvarlama }">
                                                    <input type="checkbox" class="custom-control-input" id="kenaryuvarlama"  v-model="localFormData.kenaryuvarlama">
                                                    <label class="custom-control-label" for="kenaryuvarlama">Edge Rounding /  Kenar Yuvarlama</label>
                                                    <span v-if="formHatalar.kenaryuvarlama" class="error">{{ formHatalar.kenaryuvarlama
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.satine }">
                                                    <input type="checkbox" class="custom-control-input" id="satine"  v-model="localFormData.satine">
                                                    <label class="custom-control-label" for="satine">Finishing / Satine</label>
                                                    <span v-if="formHatalar.satine" class="error">{{ formHatalar.satine
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.polisaj }">
                                                    <input type="checkbox" class="custom-control-input" id="polisaj"  v-model="localFormData.polisaj">
                                                    <label class="custom-control-label" for="polisaj">Polishing / Polisaj</label>
                                                    <span v-if="formHatalar.polisaj" class="error">{{ formHatalar.polisaj
                                                    }}</span>
                                                </div>
                                            </div>
                                           
                                            <div class="col-sm-4">
                                                <div class="custom-control custom-checkbox checked" :class="{ 'text-danger': formHatalar.oksitkaldirma }">
                                                    <input type="checkbox" class="custom-control-input" id="oksitkaldirma"  v-model="localFormData.oksitkaldirma">
                                                    <label class="custom-control-label" for="oksitkaldirma">Oxide Removal / Oksit Kaldırma </label>
                                                    <span v-if="formHatalar.oksitkaldirma" class="error">{{ formHatalar.oksitkaldirma
                                                    }}</span>
                                                </div>
                                            </div>
                                          
                                    
                                    
                                        
                                        </div>

                                    
   
                                 
                                 
                                    </div>
                                </div>
                            </div>

                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">LEVELING MACHINE / DOĞRULTMA & GERİLİM GİDERME MAKİNESİ </span>
                                        <div class="row gy-4">
                                          

                                     



                                      

                               
                                      

                                        

                                            <div class="col-sm-4 d-flex gap-2">
                                                <label  >
                                                    Material Thickness Range / Malzeme Kalınlık Aralığı</label>  

                                            </div>

                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.dogrultmamalzemekalinlikaraligi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamalzemekalinlikaraligi1" value="5" v-model="localFormData.dogrultmamalzemekalinlikaraligi" >
                                                    <label class="custom-control-label" for="dogrultmamalzemekalinlikaraligi1">0-5</label>
                                                    <span v-if="formHatalar.dogrultmamalzemekalinlikaraligi" class="error">{{ formHatalar.dogrultmamalzemekalinlikaraligi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.dogrultmamalzemekalinlikaraligi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamalzemekalinlikaraligi2" value="15" v-model="localFormData.dogrultmamalzemekalinlikaraligi" >
                                                    <label class="custom-control-label" for="dogrultmamalzemekalinlikaraligi2">1-15</label>
                                                    <span v-if="formHatalar.dogrultmamalzemekalinlikaraligi" class="error">{{ formHatalar.dogrultmamalzemekalinlikaraligi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.dogrultmamalzemekalinlikaraligi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamalzemekalinlikaraligi3" value="30" v-model="localFormData.dogrultmamalzemekalinlikaraligi" >
                                                    <label class="custom-control-label" for="dogrultmamalzemekalinlikaraligi3">1-30</label>
                                                    <span v-if="formHatalar.dogrultmamalzemekalinlikaraligi" class="error">{{ formHatalar.dogrultmamalzemekalinlikaraligi
                                                    }}</span>
                                                </div>
                                            </div>
                                        
                                            <div class="col-sm-4 d-flex gap-2">
                                                <label> Maximum Piece Width /Maksimum Parça Genişliği </label>  
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.dogrultmamaksimumparcagenisligi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamaksimumparcagenisligi1" value="600" v-model="localFormData.dogrultmamaksimumparcagenisligi" >
                                                    <label class="custom-control-label" for="dogrultmamaksimumparcagenisligi1">0-600</label>
                                                    <span v-if="formHatalar.dogrultmamaksimumparcagenisligi" class="error">{{ formHatalar.dogrultmamaksimumparcagenisligi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.malzemekalitesi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamaksimumparcagenisligi2" value="1100" v-model="localFormData.dogrultmamaksimumparcagenisligi" >
                                                    <label class="custom-control-label" for="dogrultmamaksimumparcagenisligi2">0-1100</label>
                                                    <span v-if="formHatalar.dogrultmamaksimumparcagenisligi" class="error">{{ formHatalar.dogrultmamaksimumparcagenisligi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.dogrultmamaksimumparcagenisligi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamaksimumparcagenisligi3" value="1600" v-model="localFormData.dogrultmamaksimumparcagenisligi" >
                                                    <label class="custom-control-label" for="dogrultmamaksimumparcagenisligi3">0-1600</label>
                                                    <span v-if="formHatalar.dogrultmamaksimumparcagenisligi" class="error">{{ formHatalar.dogrultmamaksimumparcagenisligi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-2 mb-2">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.dogrultmamaksimumparcagenisligi }">
                                                    <input type="radio" class="custom-control-input" id="dogrultmamaksimumparcagenisligi4" value="2000" v-model="localFormData.dogrultmamaksimumparcagenisligi" >
                                                    <label class="custom-control-label" for="dogrultmamaksimumparcagenisligi4">0-2000</label>
                                                    <span v-if="formHatalar.dogrultmamaksimumparcagenisligi" class="error">{{ formHatalar.dogrultmamaksimumparcagenisligi
                                                    }}</span>
                                                </div>
                                            </div>

                                           

                                            <div class="col-sm-8">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.dogrultmamaksimummalzemeboyu }">
                                                    <label class="form-label" for="dogrultmamaksimummalzemeboyu">
                                                        Maximum Material Length / Maksimum Malzeme Boyu</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="number"  id="dogrultmamaksimummalzemeboyu" v-model="localFormData.dogrultmamaksimummalzemeboyu">
                                                    </div>
                                                    <span v-if="formHatalar.dogrultmamaksimummalzemeboyu" class="error">{{ formHatalar.dogrultmamaksimummalzemeboyu }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.dogrultmamaksimummalzemeboyuolcu }">
                                                    <label class="form-label" for="default-textarea"> Measured / Ölçü Birimi </label>
                                                    <div class="form-control-wrap">
                                                        <v-select
                                                        v-model="localFormData.dogrultmamaksimummalzemeboyuolcu"
                                                        :options="olcuBirimleri"
                                                        label="value"
                                                        :reduce="olcu => olcu.id"
                                                        placeholder="Measured"
                                                        />
                                                    </div>
                                                    <span v-if="formHatalar.dogrultmamaksimummalzemeboyuolcu" class="error">{{ formHatalar.dogrultmamaksimummalzemeboyuolcu }}</span>
                                                </div>
                                            </div>
                                                                                
                             
                                            <div class="col-sm-8">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.dogrultmaaranilanduzlemselliktoleransi }">
                                                    <label class="form-label" for="dogrultmaaranilanduzlemselliktoleransi">
                                                        Required Flatness Tolerance / Aranılan Düzlemsellik Toleransı</label>
                                                    <div class="form-control-wrap">
                                                        <input  class="form-control" type="number"  id="dogrultmaaranilanduzlemselliktoleransi" v-model="localFormData.dogrultmaaranilanduzlemselliktoleransi">
                                                    </div>
                                                    <span v-if="formHatalar.dogrultmaaranilanduzlemselliktoleransi" class="error">{{ formHatalar.dogrultmaaranilanduzlemselliktoleransi }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.dogrultmaaranilanduzlemselliktoleransiolcu }">
                                                    <label class="form-label" for="default-textarea"> Measured / Ölçü Birimi </label>
                                                    <div class="form-control-wrap">
                                                        <v-select
                                                        v-model="localFormData.dogrultmaaranilanduzlemselliktoleransiolcu"
                                                        :options="olcuBirimleri"
                                                        label="value"
                                                        :reduce="olcu => olcu.id"
                                                        placeholder="Measured"
                                                        />
                                                    </div>
                                                    <span v-if="formHatalar.dogrultmaaranilanduzlemselliktoleransiolcu" class="error">{{ formHatalar.dogrultmaaranilanduzlemselliktoleransiolcu }}</span>
                                                </div>
                                            </div>
   

                                     
                                    

                                         

                                        
                                        </div>
                                 
                                 
                                    </div>
                                </div>
                            </div>

                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block">
                                        <div class="row gy-4">
                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.manuelcapakalmavekenaryuvarlamamakinesinot }">
                                                    <label class="form-label" for="default-textarea">Manual Deburring and Edge Rounding Note / Manuel Çapak Alma ve Kenar Yuvarlama Not</label>
                                                    <div class="form-control-wrap">
                                                        <textarea class="form-control no-resize" rows="8"   id="manuelcapakalmavekenaryuvarlamamakinesinot" v-model="localFormData.manuelcapakalmavekenaryuvarlamamakinesinot"> </textarea>
                                                    </div>
                                                    <span v-if="formHatalar.manuelcapakalmavekenaryuvarlamamakinesinot" class="error">{{ formHatalar.manuelcapakalmavekenaryuvarlamamakinesinot }}</span>
                                                </div>
                                            </div>
           
                                        </div>
                                </div>
                            </div>
                        </div>

                        <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block">
                                        <div class="row gy-4">
                            <div class="col-sm-12">
                                                <div class="form-group" :class="{ 'text-danger': formHatalar.not }">
                                                    <label class="form-label" for="default-textarea">Notes / Genel Not</label>
                                                    <div class="form-control-wrap">
                                                        <textarea class="form-control no-resize" rows="8"   id="not" v-model="localFormData.not"> </textarea>
                                                    </div>
                                                    <span v-if="formHatalar.not" class="error">{{ formHatalar.not }}</span>
                                                </div>
                                            </div>
           
                                        </div>
                                </div>
                            </div>
                        </div>

                        </div>
                        <div class="col-sm-4">

                          


                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">MATTER OF PRIORITY / ÖNCELİK</span>
                                        <div class="row gy-4">
                                            
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.oncelik }">
                                                    <input type="radio" class="custom-control-input" id="oncelik1" value="önemli" v-model="localFormData.oncelik" >
                                                    <label class="custom-control-label" for="oncelik1">Important / Önemli</label>
                                                    <span v-if="formHatalar.oncelik" class="error">{{ formHatalar.oncelik
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.oncelik }">
                                                    <input type="radio" class="custom-control-input" id="oncelik2" value="normal" v-model="localFormData.oncelik" >
                                                    <label class="custom-control-label" for="oncelik2">Normal / Normal</label>
                                                    <span v-if="formHatalar.oncelik" class="error">{{ formHatalar.oncelik
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.oncelik }">
                                                    <input type="radio" class="custom-control-input" id="oncelik3" value="takipet" v-model="localFormData.oncelik" >
                                                    <label class="custom-control-label" for="oncelik3">Follow / Takip Et</label>
                                                    <span v-if="formHatalar.oncelik" class="error">{{ formHatalar.oncelik
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                        
                                      
                                     
                                         
                                       
                                    
                                        
                                        </div>

                                    
   
                                 
                                 
                                    </div>
                                </div>
                            </div>

                            <div class="card card-bordered card-preview mb-2" >
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">VISITOR CLASS / ZİYARETÇİ TİPİ</span>
                                        <div class="row gy-4">
                                            
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.ziyaretcitipi }">
                                                    <input type="radio" class="custom-control-input" id="ziyaretcitipi1" value="sonkullanici" v-model="localFormData.ziyaretcitipi" >
                                                    <label class="custom-control-label" for="ziyaretcitipi1">End User /Son Kullanıcı</label>
                                                    <span v-if="formHatalar.ziyaretcitipi" class="error">{{ formHatalar.ziyaretcitipi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.ziyaretcitipi }">
                                                    <input type="radio" class="custom-control-input" id="ziyaretcitipi2" value="tedarikci" v-model="localFormData.ziyaretcitipi" >
                                                    <label class="custom-control-label" for="ziyaretcitipi2">Supplier / Tedarikçi</label>
                                                    <span v-if="formHatalar.ziyaretcitipi" class="error">{{ formHatalar.ziyaretcitipi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.ziyaretcitipi }">
                                                    <input type="radio" class="custom-control-input" id="ziyaretcitipi3" value="potansiyelbayi" v-model="localFormData.ziyaretcitipi" >
                                                    <label class="custom-control-label" for="ziyaretcitipi3">
                                                        Potential Dealer / Potansiyel Bayi</label>
                                                    <span v-if="formHatalar.ziyaretcitipi" class="error">{{ formHatalar.ziyaretcitipi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                        
                                      
                                     
                                         
                                       
                                    
                                        
                                        </div>

                                    
   
                                 
                                 
                                    </div>
                                </div>
                            </div>
                            <div class="card card-bordered card-preview mb-2">
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">STATUS OF ACTION / AKTİVİTE TİPİ</span>
                                        <div class="row gy-4">
                                            
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.aktivitetipi }">
                                                    <input type="radio" class="custom-control-input" id="aktivitetipi1" value="acil" v-model="localFormData.aktivitetipi" >
                                                    <label class="custom-control-label" for="aktivitetipi1">Urgent / Acil</label>
                                                    <span v-if="formHatalar.aktivitetipi" class="error">{{ formHatalar.aktivitetipi
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="custom-control custom-radio checked" :class="{ 'text-danger': formHatalar.aktivitetipi }">
                                                    <input type="radio" class="custom-control-input" id="aktivitetipi2" value="olagan" v-model="localFormData.aktivitetipi" >
                                                    <label class="custom-control-label" for="aktivitetipi2">Normal / Olağan</label>
                                                    <span v-if="formHatalar.aktivitetipi" class="error">{{ formHatalar.aktivitetipi
                                                    }}</span>
                                                </div>
                                                
                                            </div>
                                      
                                        
                                      
                                     
                                         
                                       
                                    
                                        
                                        </div>

                                    
   
                                 
                                 
                                    </div>
                                </div>
                            </div>  

                           
                     
                        <div class="card card-bordered card-preview mb-2" v-if="localFormData.seskaydi">
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">UPLOADED VOICE RECORDING/ YÜKLENMİŞ SES KAYDI</span>
                                        
                                        <audio :src="$globalVariable.uploadUrl +localFormData.seskaydi" controls></audio>
                           
                                        
                                </div>
                            </div>  
                        </div> 

                            <div class="card card-bordered card-preview mb-2">
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">
                                        VOICE RECORDER / SES KAYDEDİCİ</span>
                                        

                                        <div class="row gy-4">
                                            <button type="button" class="btn btn-primary rounded-pill" @click="startRecording" :disabled="isRecording"> <em class="icon ni ni-mic"></em>Start Recording / Kayda Başla</button>
                                            <button type="button" class="btn btn-primary rounded-pill" @click="stopRecording" :disabled="!isRecording"> <em class="icon ni ni-stop"></em> Stop Recording / Kaydı Durdur</button>
                                            <audio v-if="audioURL" :src="audioURL" controls></audio>
                                        </div>
                                </div>
                            </div>  
                        </div> 

                            <div class="card card-bordered card-preview mb-2">
                                <div class="card-inner">
                                    <div class="preview-block"><span class="preview-title-lg overline-title">Business Card Images / Kartvizit Görselleri</span>
                                        <div class="row gy-4">
                                            

                                      



<div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.kartviziton }"> 
       
    <img 
        v-if="localFormData.kartviziton" 
        class="rounded img-cover mb-2 h-50" 
        :src="$globalVariable.uploadUrl + localFormData.kartviziton" 
        alt="Kartvizit Ön Görsel" 
    />
    


    <div class="alert alert-info alert-dismissible fade show" role="alert" v-if="loading">    
        <strong>Kartvizit Okunuyor ... </strong>Lütfen Bekleiyiniz    
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>

    <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="ocrResult">    
        <strong>Okuma Verileri</strong> {{ ocrResult }}    
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>

       <picture-input 
         ref="profil"
         width="600" 
         height="600" 
         margin="16" 
         accept="image/jpeg,image/png" 
         size="10" 
         button-class="btn"
         :custom-strings="{
           upload: '<h1>Kartvizit Ön Görsel</h1>',
           drag: 'Kartvizit Ön Görseli Tıklayın veya sürükleyip bırakın'
         }"
         @change="kartvizitonDegistir">
       </picture-input>
     </div>	
       <span v-if="formHatalar.kartviziton" class="error">{{ formHatalar.kartviziton }}</span>
  
   
   <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.kartvizitarka }"> 
      

    <img 
    v-if="localFormData.kartviziton" 
    class="rounded img-cover mb-2 h-50" 
    :src="$globalVariable.uploadUrl + localFormData.kartvizitarka" 
    alt="Kartvizit Arka Görsel" 
  />


       <picture-input 
         ref="profil"
         width="600" 
         height="600" 
         margin="16" 
         accept="image/jpeg,image/png" 
         size="10" 
         button-class="btn"
         :custom-strings="{
           upload: '<h1>Kartvizit Arka Görsel</h1>',
           drag: 'Kartvizit Arka Görseli Tıklayın veya sürükleyip bırakın'
         }"
         @change="kartvizitarkaDegistir">
       </picture-input>
     </div>	
       <span v-if="formHatalar.kartvizitarka" class="error">{{ formHatalar.kartvizitarka }}</span>
  
                                     
                                        

                                        
                                        </div>
                                 
                                 
                                    </div>
                                </div>
                            </div>


                        </div>
                      
                        <div class="col-sm-8  mt-4">
                            <div class="d-grid gap-2 ">  
                                <button type="submit" class="btn btn-primary btn-lg "><em
                                                        class="icon ni ni-check"></em><span> Save / Kaydet</span></button>
                            </div>
                        </div>
                        </div>
                

                                    </form>
                           


                        </div>
                    </div>
                </div>

            </div>




       
    </div>
</template>



<script>
import axiosCustom from "@/services/axiosCustom";
import vSelect from "vue-select";




import PictureInput from 'vue-picture-input'



import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

import Tesseract from 'tesseract.js';





export default {
components: {
   
      vSelect,
  
  
    PictureInput,
  
  
  
    VueCtkDateTimePicker,
  
  

  
},

data() {
  return {
    
    kartvizitonSecili: null,
    
    kartvizitarkaSecili: null,
    
    
  firmalar: [],
  tumfirmalar: [],
  
  etkinlikler: [],
  
  kisiler: [],
  tumkisiler: [],
  
  kullanicilar: [],
  


  
    localFormData: { ...this.formData }, 
    formHatalar:{},

   formIslem:'ekle', 

   olcuBirimleri: [
        { id: 'cm', value: 'cm' },
        { id: 'mm', value: 'mm' },
        { id: 'inc', value: 'inç' },  // İnç birimi eklendi
    ],

   mediaRecorder: null,
      audioChunks: [],
      audioURL: null,
      isRecording: false,
  

      
      ocrResult: null,
      loading: false,
  };
},
created() {
  
    this.gorusmeDetayGetir() 
  this.firmalarGetir();
  
  this.etkinliklerGetir();
  
  this.kisilerGetir();
  
  this.kullanicilarGetir();
  
   

  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

          this.localFormData.dogrultmaaranilanduzlemselliktoleransiolcu='mm';
          this.localFormData.dogrultmamaksimummalzemeboyuolcu='mm';
 
          if(!this.localFormData.oncelik){
            this.localFormData.oncelik="normal";
            }

          

          if(this.localFormData.agircapakalma=='1'){
              this.localFormData.agircapakalma=true;
            }else{
              this.localFormData.agircapakalma=false;
            }
          
          if(this.localFormData.yuzeycapakalma=='1'){
            this.localFormData.yuzeycapakalma=true;
            }else{
              this.localFormData.yuzeycapakalma=false;
            }
          
          if(this.localFormData.kenaryuvarlama=='1'){
            this.localFormData.kenaryuvarlama=true;
            }else{
              this.localFormData.kenaryuvarlama=false;
            }
          
          if(this.localFormData.satine=='1'){
            this.localFormData.satine=true;
            }else{
              this.localFormData.satine=false;
            }
          
          if(this.localFormData.polisaj=='1'){
            this.localFormData.polisaj=true;
            }else{
              this.localFormData.polisaj=false;
            }
          
          if(this.localFormData.oksitkaldirma=='1'){
            this.localFormData.oksitkaldirma=true;
            }else{
              this.localFormData.oksitkaldirma=false;
            }
          
          if(this.localFormData.hizliekleme=='1'){
            this.localFormData.hizliekleme=true;
            }else{
              this.localFormData.hizliekleme=false;
            }
          
          
          
         
          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },

      'localFormData.firma': {
        handler(newFirma) {
            this.firmalarDetayGetir(newFirma); 
        // Firmalar değiştiğinde yapılacak işlemler
        },
        immediate: true, // İlk başta da tetiklenir
    },
    'localFormData.kisi': {
        handler(newKisi) {
            this.kisiDetayGetir(newKisi); 
        // Kişi değiştiğinde yapılacak işlemler
        },
        immediate: true, // İlk başta da tetiklenir
    }
    },
methods: {
  




        async gorusmeDetayGetir() {
            if (this.$route.params.id == '0' || this.$route.params.id == '') {
                this.formIslem = 'ekle';

        

                this.tarihlerOtomatikDoldur();
                
            } else {
                this.formIslem = 'duzenle';

                try {





                    const response = await axiosCustom.get("gorusmebilgiler/detay/" + this.$route.params.id);
                    this.localFormData = response.data ?? {};



                } catch (error) {
                    console.error("gorusmebilgiler alma hatası: ", error);
                }

            }
           

        },

        async firmalarGetir() {
  try {
    const response = await axiosCustom.get("firmalar"); 
    this.firmalar = response.data;
    this.tumfirmalar = response.data; // Firmaların yedeği
  } catch (error) {
    console.error("Firmalar alma hatası: ", error);
  }
},

async firmalarDetayGetir(id) {
  try {
    if (id != null) {
      const response = await axiosCustom.get(`firmalar/detay/${id}`);
      this.firmalar[0] = response.data;
      this.kisiler = response.data.kisiler || []; // Detaydan kişiler varsa al,

      this.localFormData.firmaad = response.data.unvan;
      this.localFormData.firmaulke = response.data.ulke;
      this.localFormData.firmaemail = response.data.email;
      this.localFormData.firmatelefon = response.data.telefon;


    } else {
      // ID yoksa tüm firmaları ve kişileri geri yükle
      this.firmalar = this.tumfirmalar || [];
      this.kisiler = this.tumkisiler || []; // Kişiler için yedek veriyi kullan

      
      this.localFormData.firmaad = "";
      this.localFormData.firmaulke = "";
      this.localFormData.firmaemail = "";
      this.localFormData.firmatelefon = "";
    }
  } catch (error) {
    console.error("Veri çekme hatası: ", error);
  }
},

formatDate(tarih) {
    // 'YYYY-MM-DD HH:mm:ss' formatını 'YYYY-MM-DDTHH:mm:ss' formatına çevir
    return tarih.replace(' ', 'T');
  },
  
  otomatikEtkinlikSec() {
    // Etkinlikleri döngüyle kontrol et
    this.etkinlikler.forEach(etkinlik => {
      // Tarihleri formatDate fonksiyonuyla düzenle ve Date nesnesine çevir
      let basTarih = new Date(this.formatDate(etkinlik.bastarih));
      let bitisTarih = new Date(this.formatDate(etkinlik.bittarih));

      // Eğer bugünün tarihi basTarih ve bitisTarih arasında ise
      if (new Date() >= basTarih && new Date() <= bitisTarih) {
        this.localFormData.etkinlik = etkinlik.id;
      }
    });
  },

async kisilerGetir() {
  try {
    const response = await axiosCustom.get("kisiler"); 
    this.kisiler = response.data;
    this.tumkisiler = response.data; // Kişilerin yedeği
  } catch (error) {
    console.error("Kişiler alma hatası: ", error);
  }
},

async kisiDetayGetir(id) {
  try {
    if (id != null) {
      const response = await axiosCustom.get(`kisiler/detay/${id}`);


      this.localFormData.firmakisiadsoyad = response.data.adsoyad;
      this.localFormData.firmakisiunvan = response.data.gorev;
      this.localFormData.firmakisiemail = response.data.email;
      this.localFormData.firmakisitelefon = response.data.telefon;

    } else {
 
      this.localFormData.firmakisiadsoyad = "";
      this.localFormData.firmakisiunvan = "";
      this.localFormData.firmakisiemail = "";
      this.localFormData.firmakisitelefon = "";
    
    }
  } catch (error) {
    console.error("Veri çekme hatası: ", error);
  }
},
  async etkinliklerGetir() {
    try {
      const response = await axiosCustom.get("etkinlikler"); 
      this.etkinlikler = response.data;
      
      if(this.localFormData.etkinlik==0 ||  this.localFormData.etkinlik==null){
                this.otomatikEtkinlikSec()
            }
    } catch (error) {
      console.error("etkinlikler alma hatası: ", error);
    }
  },
  

  
  async kullanicilarGetir() {
    try {
      const response = await axiosCustom.get("kullanicilar"); 
      this.kullanicilar = response.data;
    } catch (error) {
      console.error("kullanicilar alma hatası: ", error);
    }
  },
  
  
  tarihlerOtomatikDoldur() {
            const today = new Date();

            // Tarih formatını YYYY-MM-DD HH:mm:ss şeklinde ayarlıyoruz.
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            };

            this.localFormData.tarih = formatDate(today);

          
        },


  formDogrula() {
    this.formHatalar = {};
    var kontrol=true;
    

    return kontrol;
  },
  async  gonder() {
    if(this.formDogrula()){
  // FormData oluştur
  const newFormData = new FormData();

  if (this.audioChunks.length > 0) {
  const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
  newFormData.append('audio', audioBlob, 'recording.wav');
}

  newFormData.append("firmaad", this.localFormData.firmaad ?? '');
  newFormData.append("firmaulke", this.localFormData.firmaulke ?? '');
  newFormData.append("firmakisiadsoyad", this.localFormData.firmakisiadsoyad ?? '');
  newFormData.append("firmakisiunvan", this.localFormData.firmakisiunvan ?? '');
  newFormData.append("firmakisiemail", this.localFormData.firmakisiemail ?? '');
  newFormData.append("firmakisitelefon", this.localFormData.firmakisitelefon ?? '');
  newFormData.append("firmaemail", this.localFormData.firmaemail ?? '');
  newFormData.append("firmatelefon", this.localFormData.firmatelefon ?? '');


  newFormData.append("oncelik", this.localFormData.oncelik ?? '');
  newFormData.append("ziyaretcitipi", this.localFormData.ziyaretcitipi ?? '');
  newFormData.append("aktivitetipi", this.localFormData.aktivitetipi ?? '');
  newFormData.append("lazer", this.localFormData.lazer ?? '');
  newFormData.append("oksijen", this.localFormData.oksijen ?? '');
  newFormData.append("plazma", this.localFormData.plazma ?? '');
  newFormData.append("punch", this.localFormData.punch ?? '');
  newFormData.append("diger", this.localFormData.diger ?? '');
  

  newFormData.append("dogrultmaaranilanduzlemselliktoleransiolcu", this.localFormData.dogrultmaaranilanduzlemselliktoleransiolcu ?? '');
  newFormData.append("dogrultmamaksimummalzemeboyuolcu", this.localFormData.dogrultmamaksimummalzemeboyuolcu ?? '');

  newFormData.append("taslamapersonelsayi", this.localFormData.taslamapersonelsayi ?? '');
  newFormData.append("malzemekalinligiaraligi", this.localFormData.malzemekalinligiaraligi ?? '');
  newFormData.append("malzemegenislikaraligi", this.localFormData.malzemegenislikaraligi ?? '');
  newFormData.append("malzemekalitesi", this.localFormData.malzemekalitesi ?? '');
  newFormData.append("malzemesekli", this.localFormData.malzemesekli ?? '');
  newFormData.append("tutucusistem", this.localFormData.tutucusistem ?? '');
  newFormData.append("dogrultmamalzemekalinlikaraligi", this.localFormData.dogrultmamalzemekalinlikaraligi ?? '');
  newFormData.append("dogrultmamaksimumparcagenisligi", this.localFormData.dogrultmamaksimumparcagenisligi ?? '');
  newFormData.append("dogrultmamaksimummalzemeboyu", this.localFormData.dogrultmamaksimummalzemeboyu ?? '');
  newFormData.append("dogrultmaaranilanduzlemselliktoleransi", this.localFormData.dogrultmaaranilanduzlemselliktoleransi ?? '');
  newFormData.append("manuelcapakalmavekenaryuvarlamamakinesinot", this.localFormData.manuelcapakalmavekenaryuvarlamamakinesinot ?? '');
  newFormData.append("not", this.localFormData.not ?? '');
  newFormData.append("tarih", this.localFormData.tarih ?? '');
  newFormData.append("firma", this.localFormData.firma ?? '');
  newFormData.append("etkinlik", this.localFormData.etkinlik ?? '');
  newFormData.append("kisi", this.localFormData.kisi ?? '');
  newFormData.append("gorusmeyapan", this.localFormData.gorusmeyapan ?? '');
   
  newFormData.append("kartviziton",  this.kartvizitonSecili ?? '');
  newFormData.append("kartvizitarka",  this.kartvizitarkaSecili ?? '');

  newFormData.append("agircapakalma",  this.localFormData.agircapakalma ?? '');
  newFormData.append("yuzeycapakalma",  this.localFormData.yuzeycapakalma ?? '');
  newFormData.append("kenaryuvarlama",  this.localFormData.kenaryuvarlama ?? '');
  newFormData.append("satine",  this.localFormData.satine ?? '');
  newFormData.append("polisaj",  this.localFormData.polisaj ?? '');
  newFormData.append("oksitkaldirma",  this.localFormData.oksitkaldirma ?? '');
  newFormData.append("hizliekleme",  0);

  try {
  if (this.formIslem === "duzenle") {
    axiosCustom
      .post("gorusmebilgiler/duzenle/" + this.localFormData.id, newFormData)
      .then(() => {
        

        this.$toast.success("Görüşme Bilgi Düzenlendi");
      })
      .catch((error) => {
        console.error("Güncelleme hatası: ", error);
        this.$toast.error("Güncelleme hatası");
      });
  } else {
    axiosCustom
      .post("gorusmebilgiler/ekle", newFormData)
      .then(() => {
        

        this.$toast.success("Record created / Yeni Görüşme Bilgi Eklendi");
     
      })
      .catch((error) => {
        console.error("Ekleme hatası: ", error);
        this.$toast.error("Ekleme hatası");
      });
  }
} catch (error) {
    console.error('Kaydetme hatası: ', error);
    this.$toast.error('Kaydetme hatası');
  }
} 
  },
  
  iptalEt() {
    this.formIptal();
  },

  

  
  kartvizitonDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.kartvizitonSecili = event.target.files[0];

        const file = event.target.files[0];
                if (file) {
                    this.performOCR(file);
                }

        // Resmin önizlemesini gösterme
        if (this.kartvizitonSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.kartvizitonOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.kartvizitonSecili);
        }
    },
    
  kartvizitarkaDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.kartvizitarkaSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.kartvizitarkaSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.kartvizitarkaOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.kartvizitarkaSecili);
        }
    },





    async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(stream);
      this.audioChunks = [];

      this.mediaRecorder.start();
      this.isRecording = true;
      this.$toast.success('Ses kaydı başlatıldı.');

      this.mediaRecorder.ondataavailable = (event) => {
        this.audioChunks.push(event.data);
      };

      this.mediaRecorder.onstop = () => {
        const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
        this.audioURL = URL.createObjectURL(audioBlob);
        this.$toast.success('Ses kaydı durduruldu.');
      };
    } catch (error) {
      console.error('Mikrofon erişim hatası:', error);
      this.$toast.error('Mikrofon erişim hatası: ' + error.message);
    }
  },

  stopRecording() {
    if (this.isRecording) {
      this.mediaRecorder.stop();
      this.isRecording = false;
    }
  },







  performOCR(file) {
      this.loading = true;
      Tesseract.recognize(
        file,
        'eng', // OCR dili, burada İngilizce (eng) olarak ayarlandı.
        {
          logger: (m) => console.log(m), // OCR ilerleme durumu
        }
      )
        .then(({ data: { text } }) => {
          this.ocrResult = text;
          this.extractContactInfo(text); // Verileri kategorilere ayırma
          this.loading = false;
        })
        .catch((error) => {
          console.error('OCR hatası:', error);
          this.loading = false;
        });
    },

    extractContactInfo(text) {
      // Telefon numarası için regex (örnek Türk formatı)
      const phoneRegex = /(\+?\d{1,4}[-.\s]?)?(\(?\d{3,4}\)?[-.\s]?)?\d{3,4}[-.\s]?\d{4}/;
      // E-posta adresi için regex
      const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
      // Ad ve soyadın genellikle iki kelime olduğunu varsayıyoruz (manuel düzenleme gerekebilir)
      const nameRegex = /^[A-Za-z\s]+$/;

      // Metinden verileri ayıklama
      const phoneMatch = text.match(phoneRegex);
      const emailMatch = text.match(emailRegex);
      const nameMatch = text.split('\n').find(line => line.match(nameRegex)); // İlk ad-soyad olarak kabul edilir.

      this.localFormData.firmakisiadsoyad=nameMatch;
      this.localFormData.firmakisitelefon=phoneMatch;
      this.localFormData.firmakisiemail=emailMatch;
     
    }


 
 
},
};
</script>

  